(() => {
  function activateTab(tab) {
    const menu = tab.closest(".homland-product-mega-menu");

    if (!menu) {
      return;
    }

    const panelId = tab.getAttribute("aria-controls");

    menu.querySelectorAll("[data-homland-mega-tab]").forEach((item) => {
      const isActive = item === tab;

      item.classList.toggle("is-active", isActive);
      item.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    menu.querySelectorAll("[data-homland-mega-panel]").forEach((panel) => {
      const isActive = panel.id === panelId;

      panel.classList.toggle("is-active", isActive);
      panel.toggleAttribute("hidden", !isActive);
    });
  }

  function bindMenu(menu) {
    if (menu.dataset.homlandMegaBound === "true") {
      return;
    }

    menu.dataset.homlandMegaBound = "true";

    menu.querySelectorAll("[data-homland-mega-tab]").forEach((tab) => {
      tab.addEventListener("pointerenter", () => {
        if (window.matchMedia("(hover: hover)").matches) {
          activateTab(tab);
        }
      });

      tab.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        activateTab(tab);
      });

      tab.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          activateTab(tab);
        }
      });
    });
  }

  function bindAllMenus() {
    document.querySelectorAll(".homland-product-mega-menu").forEach(bindMenu);
  }

  document.addEventListener("pointerover", (event) => {
    const tab = event.target.closest("[data-homland-mega-tab]");

    if (tab && window.matchMedia("(hover: hover)").matches) {
      activateTab(tab);
    }
  }, true);

  document.addEventListener("click", (event) => {
    const tab = event.target.closest("[data-homland-mega-tab]");

    if (tab) {
      event.preventDefault();
      event.stopPropagation();
      activateTab(tab);
    }
  }, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindAllMenus);
  } else {
    bindAllMenus();
  }

  document.addEventListener("shopify:section:load", bindAllMenus);
})();
